import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/core';
import { AudioFile, AudioFileNumberOfReplays, AudioFileRule } from '../../../domain';
export var UPDATE_QUESTION_AUDIO_FILE_USE_CASE = 'UPDATE_QUESTION_AUDIO_FILE_USE_CASE';
export var UPDATE_QUESTION_AUDIO_FILE_SIZE = 25;
export var UpdateQuestionAudioFileUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateQuestionAudioFileUseCase, _UseCase);

  var _super = _createSuper(UpdateQuestionAudioFileUseCase);

  function UpdateQuestionAudioFileUseCase() {
    _classCallCheck(this, UpdateQuestionAudioFileUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(UpdateQuestionAudioFileUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var data, currentQuestion, rule, audioFileRuleOrError, audioFileOrError, updatedResultOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = useCaseInput.data, currentQuestion = useCaseInput.currentQuestion;
                rule = data.rule;
                audioFileRuleOrError = AudioFileRule.create(_objectSpread(_objectSpread({}, rule), {}, {
                  numberOfReplays: AudioFileNumberOfReplays.create(rule.numberOfReplays).getValue()
                }));

                if (!audioFileRuleOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(audioFileRuleOrError));

              case 5:
                audioFileOrError = AudioFile.create(_objectSpread(_objectSpread({}, data), {}, {
                  rule: audioFileRuleOrError.getValue()
                }), data.id);

                if (!audioFileOrError.isFailure) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", mappingResultError(audioFileOrError));

              case 8:
                updatedResultOrError = currentQuestion.updateAudioFile(audioFileOrError.getValue());

                if (!updatedResultOrError.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", mappingResultError(updatedResultOrError));

              case 11:
                return _context.abrupt("return", Result.ok(currentQuestion));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateQuestionAudioFileUseCase;
}(UseCase);